import { Component, Input } from '@angular/core';

@Component({
  selector: 'cigna-responsive-title',
  templateUrl: './responsive-title.component.html',
  styleUrls: ['./responsive-title.component.scss'],
})
export class ResponsiveTitleComponent {
  defaultCharacterLength = 70;
  @Input() title: string;
  @Input() classNames?: string;
  @Input() characterLength?: number;
  @Input() smCharacterLength?: number;
  @Input() mdCharacterLength?: number;
  @Input() lgCharacterLength?: number;
}
